// SPDX-FileCopyrightText: 2025-2026 TU Wien.
// SPDX-License-Identifier: MIT

document.addEventListener("DOMContentLoaded", () => {
  for (const block of document.querySelectorAll(".code-block")) {
    const button = block.querySelector(".copy-btn");
    const codeText = block.innerText.trim();

    // Skip this block if the required elements are missing
    if (!button) return;

    const resetTooltip = (btn) => {
      btn.dataset.tooltip = "Copy to clipboard";
      btn.querySelector("i").classList.replace("check", "copy");
    };

    const handleCopy = () => {
      navigator.clipboard
        .writeText(codeText)
        .then(() => onCopySuccess(button))
        .catch((error) => console.error("Failed to copy: ", error));
    };

    const onCopySuccess = (btn) => {
      btn.dataset.tooltip = "Copied!";
      btn.querySelector("i").classList.replace("copy", "check");

      setTimeout(resetTooltip, 2000, btn);
    };

    button.addEventListener("click", handleCopy);
  }
});
